<template>
  <div class="resource-logins">
    <div class="header-title">{{ $t('newProject.resources.login') }}</div>

    <div class="login-row" v-for="item in items" :key="item.id">
      <span class="login" :title="item.username"> {{ item.username || '-' }} </span>
      <v-icon class="copy-login" small @click="copyLoginToClipboard(item)">content_copy</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResourceLogins',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    copyLoginToClipboard(item) {
      this.$clipboard(item.username);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.resource-logins {
  .header-title {
    padding: rem(6);
    display: inline-flex;
    color: var(--text-tertiary);
    font-size: rem(10);
    letter-spacing: rem(0.8);
    line-height: rem(10);
    text-transform: uppercase;
  }

  .login-row {
    display: flex;
    align-items: center;
    border-radius: $radius-sm;
    background-color: var(--bg-tertiary);
    height: rem(28);
    padding: rem(6);
    margin-bottom: rem(2);

    .copy-login {
      margin-left: rem(14);
      color: var(--brand-primary);
    }
  }
}
</style>
